import { render, staticRenderFns } from "./KanbanStageIndicator.vue?vue&type=template&id=2d2691e8&scoped=true&"
import script from "./KanbanStageIndicator.vue?vue&type=script&lang=js&"
export * from "./KanbanStageIndicator.vue?vue&type=script&lang=js&"
import style0 from "./KanbanStageIndicator.vue?vue&type=style&index=0&id=2d2691e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2691e8",
  null
  
)

export default component.exports